/* System defined core library */
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { SelectedExamDetailService } from '../../../scheduling/shared/services/selected-exam-detail.service';

/* User defined models */
import { ContentResponse } from '../../models/common/shared.model';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent {

  /* User defined private/public variables */
  public isParentalConsentSelected: boolean = false;
  public isPrivacySelected: boolean = false;
  public dataConsentContent: string;

  /* Service subscriptions */
  translateLanguage$: Subscription;

  /* Input-OutPut parameters decalartions */
  @Input() public contentDetails: ContentResponse = null;
  @Input() public dataConsentDetails: string = null;
  @Input() public programCode: string;
  @Input() public options: string[];
  @Output() consentSelected = new EventEmitter<boolean>();
  @Output() ndaSelected = new EventEmitter<string>();
  @Output() privacySelected = new EventEmitter<boolean>();
  @Output() dataSelected = new EventEmitter<boolean>();

  @ViewChild('focusContainer') contentDiv: ElementRef;

  /* Constructor declaration with required injected services */
  constructor(
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });
  }

  setFocusToContent(): void {
    this.contentDiv.nativeElement.focus();
  }

  /* On change of NDA selection  */
  OnNDAChange(event: any): void {
    this.ndaSelected.emit(event);
  }

  /* On change of age selection  */
  OnConsentChange(event: any): void {
    this.consentSelected.emit(event.target.checked);
  }

  /* On change of privacy selection */
  OnPrivacyChange(event: any): void {
    this.privacySelected.emit(event.target.checked);
  }

  /* On change of data transfer selection */
  OnDataChange(event: any): void {
    this.dataSelected.emit(event.target.checked);
  }
}
